import React from 'react';
import { QuoteListComponent } from './components';

const Quotes: React.FC = () => {
  return <QuoteListComponent />;
};

export default Quotes;

